var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiberia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_26_4335)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26_4335",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26_4335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0927 3L3 13.9073V15.7218L3.91061 16.6324L3 17.543V19.3575L3.91061 20.2682L3 21.1788V23H37.2819V21.1788L36.3713 20.2682L37.2819 19.3575V17.543L36.3713 16.6324L37.2819 15.7218V13.9073L36.3713 12.9967L37.2819 12.086V10.2715L36.3713 9.3609L37.2819 8.45029V6.63576L36.3713 5.72514L37.2819 4.81453V3H12.0927Z",
    fill: "#AE1D3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21.1788H37.2819V19.3575H3V21.1788ZM3 17.543H37.2819V15.7218H3V17.543ZM12.0927 4.81453L3 12.086V13.9073H37.2819V12.086H12.0927L10.2782 10.2648H37.2819V8.45028H10.2715V6.63575H37.2819V4.81453H12.0927Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0927 3H3V12.0927H12.0927V3Z",
    fill: "#262D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.54635 4.81453L6.7027 7.40576L8.2561 7.91463L7.54635 4.81453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.54639 4.81453L8.39005 7.40576L6.82996 7.91463L7.54639 4.81453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1376 6.69601H7.41248V8.33646L10.1376 6.69601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1376 6.69601L7.9347 8.30298L6.97052 6.97723L10.1376 6.69601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.14663 9.74925L8.30297 7.15132L6.74957 7.66019L9.14663 9.74925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.14667 9.74925L6.94379 8.14228L7.90127 6.82323L9.14667 9.74925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93939 9.74925L8.14897 8.14228L7.18479 6.82323L5.93939 9.74925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93939 9.74925L6.78305 7.15132L8.34314 7.66019L5.93939 9.74925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94843 6.69601L7.158 8.30298L8.12218 6.97723L4.94843 6.69601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94843 6.69601H7.68026V8.33646L4.94843 6.69601Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_26_4335",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26_4335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26_4335",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiberia);
export default __webpack_public_path__ + "static/media/Liberia.eb29eb0d9be7279050f13c91e7628f73.svg";
export { ForwardRef as ReactComponent };